import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getPresets(companyId, instanceName) {
	return dataTransferWrap(ModulesMap.PRESETS,dtConfig[ModulesMap.PRESETS].getPresets, {
		urlParams: {
			companyId,
			instanceName,
		},
	})
}

function getMultiplePresets(companyId, query = {}) {
	const params = {}
	if (query.codes) {
		params.codes = query.codes
	}
	if (query.substring) {
		params.substring = query.substring
	}
	return dataTransferWrap(ModulesMap.PRESETS,dtConfig[ModulesMap.PRESETS].getMultiplePresets, {
		urlParams: {
			companyId,
		},
		params,
	})
}

function createPreset(companyId, instanceName, payload) {
	return dataTransferWrap(ModulesMap.PRESETS,dtConfig[ModulesMap.PRESETS].createPreset, {
		urlParams: {
			companyId,
			instanceName,
		},
		...payload,
	})
}

function deletePreset(companyId, instanceName, presetId) {
	return dataTransferWrap(ModulesMap.PRESETS,dtConfig[ModulesMap.PRESETS].deletePreset, {
		urlParams: {
			companyId,
			instanceName,
			presetId,
		},
	})
}

function editPreset(companyId, instanceName, presetId, payload) {
	return dataTransferWrap(ModulesMap.PRESETS,dtConfig[ModulesMap.PRESETS].editPreset, {
		...payload,
		urlParams: {
			companyId,
			presetId,
			instanceName,
		},
	})
}

function patchPreset(companyId, instanceName, presetId, payload) {
	return dataTransferWrap(ModulesMap.PRESETS,dtConfig[ModulesMap.PRESETS].patchPreset, {
		...payload,
		urlParams: {
			companyId,
			presetId,
			instanceName,
		},
	})
}

function cloneToCompanyPreset(companyId, instanceName, presetId, query = {}) {
	return dataTransferWrap(ModulesMap.PRESETS, dtConfig[ModulesMap.PRESETS].cloneToCompanyPreset, {
		urlParams: {
			companyId,
			presetId,
			instanceName,
		},
		params: query,
	})
}

function changePresetsOrder(companyId, instanceName, payload) {
	return dataTransferWrap(ModulesMap.PRESETS,dtConfig[ModulesMap.PRESETS].changePresetsOrder, {
		urlParams: {
			companyId,
			instanceName,
		},
		order: payload,
	})
}

export default {
	getPresets,
	getMultiplePresets,
	deletePreset,
	editPreset,
	patchPreset,
	cloneToCompanyPreset,
	createPreset,
	changePresetsOrder,
}
